import Call from '../Call';

const AdkLinks = {
    get() {
        return Call(`adkLinks`);
    },

    getTypes() {
        return Call(`adkLinks/type`);
    },

    save(link) {
        return Call('adkLinks','POST', link);
    },

    update(type, link) {
        return Call(`adkLinks/${type}`,'PUT', link);
    },

    updateDomain(domain, platform) {
        const paths = {
            'legacy': 'adkLinks/domain',
            'desktop': 'adkLinks/domain/desktop'
        }

        return Call(paths[platform],'PUT', { domain });
    },

    remove(type) {
        return Call(`adkLinks/${type}`,'DELETE');
    }
};

export default AdkLinks;


// WEBPACK FOOTER //
// ./src/services/API/components/AdkLinks.js